import { ProjectExternalCost as CeresProjectExternalCost, ProjectProfile } from '@ceres/domain';

export class ProjectExternalCost implements CeresProjectExternalCost {

    id: number;    
    project: ProjectProfile;
    october: number;
    november: number;
    december: number;
    january: number;
    february: number;
    march: number;
    april: number;
    may: number;
    june: number;
    july: number;
    august: number;
    september: number;
    markup: number;

    constructor(object?: Partial<ProjectExternalCost>) {
        if (object) {
            Object.assign(this, object);
        }
    }
}